<template>
    <section id="home-slide-prices" class="p-5 text-start container-fluid">

        <div class="my-5">
            <h1>{{ gettext("Nos formules") }}</h1>
            <small class="shrink-4">{{ gettext("Des formules adaptées à tous vos besoins") }}</small>
        </div>

        <div class="row text-center" style="max-width: 800px; margin: 0 auto;">
            <div id="price-subs" class="col-lg card p-0 m-2">
                <div class="card-header">
                    <h4 class="my-0 font-weight-normal">{{ gettext("Habitat") }}</h4>
                </div>
                <div class="card-body">
                    <h1 class="card-title pricing-card-title">{{ gettext("Sur devis") }}</h1>
                    <p class="px-5">
                        Gestion collaborative de plusieurs entreprises depuis un seul compte.
                    </p>
                    <ul class="text-start ms-lg-5 ps-lg-5">
                        <li>{{ gettext("Tenue des registres") }}</li>
                        <li>{{ gettext("Organisation illimité de réunions") }}</li>
                        <li>{{ gettext("Création de documents") }}</li>
                        <li>{{ gettext("Convocations électroniques") }}</li>
                        <li>{{ gettext("Vote en ligne") }}</li>
                        <li>{{ gettext("Création du PV") }}</li>
                        <li>{{ gettext("Forfait intégration") }}</li>
                    </ul>
                </div>
                <div class="pb-3">
                    <button type="button" class="btn btn-md btn-block btn-outline-primary" onclick="openCrisp()">{{ gettext("Demander plus d'informations") }}</button>
                </div>
            </div>

            <div id="price-devis" class="col-lg card p-0 m-2">
                <div class="card-header">
                    <h4 class="my-0 font-weight-normal">{{ gettext("Habitat +") }}</h4>
                </div>
                <div class="card-body">
                    <h1 class="card-title pricing-card-title">{{ gettext("Options") }}</h1>
                    <p>{{ gettext("Pour aller plus loin.") }}</p>
                    <p>&nbsp;</p>
                    <ul class="text-start ms-lg-5 ps-lg-5">
                        <li>{{ gettext("Toutes les options de la formule Habitat") }}</li>
                        <li>{{ gettext("Forfait intégration") }}</li>
                        <li>{{ gettext("Assistance premium") }}</li>
                    </ul>
                </div>
                <div class="pb-3">
                    <button type="button" class="btn btn-md btn-block btn-outline-primary" onclick="openCrisp()">{{ gettext("Demander plus d'informations") }}</button>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import slide from "@/pages/habitat/slideHabitat/slide.js";

export default {
    mixins: [slide],
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";
#home-slide-prices {
    background-color: white;
    color: $primary;

    #price-simple {
        border: 10px solid $bluek;
    }

    #price-subs {
        border: 10px solid $bluec;
    }

    #price-devis {
        border: 10px solid nth($gray, 5);
    }
}
</style>
